var _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#756CD9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9995 20.7997C19.3484 20.7997 18.7242 20.5469 18.2638 20.0969C17.8035 19.6467 17.5449 19.0363 17.5449 18.3997V13.5997C17.5449 12.7422 18.0128 11.9498 18.7722 11.5213C19.5316 11.0925 20.4674 11.0925 21.2267 11.5213C21.9861 11.9498 22.454 12.7422 22.454 13.5997V18.3997C22.454 19.0363 22.1954 19.6467 21.7352 20.0969C21.2748 20.5469 20.6506 20.7997 19.9995 20.7997ZM19.9995 12.7997C19.7825 12.7997 19.5743 12.884 19.4209 13.034C19.2675 13.184 19.1813 13.3875 19.1813 13.5997V18.3997C19.1813 18.6856 19.3372 18.9497 19.5904 19.0926C19.8435 19.2354 20.1554 19.2354 20.4086 19.0926C20.6617 18.9497 20.8176 18.6856 20.8176 18.3997V13.5997C20.8176 13.3875 20.7314 13.184 20.578 13.034C20.4246 12.884 20.2164 12.7997 19.9995 12.7997Z",
    fill: "#756CD9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8184 15.2H18.2984V16.8H11.8184V15.2Z",
    fill: "#756CD9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0127 15.2H28.4927V16.8H22.0127V15.2Z",
    fill: "#756CD9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.818 11.8719H19.1816V9.11188L19.9425 8.99992L20.2288 8.15991C20.8916 8.35991 20.8916 8.62382 20.818 11.8719V11.8719Z",
    fill: "#756CD9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3636 23.4V24.1281C27.3636 25.7915 26.6879 27.3868 25.4849 28.5631C24.2819 29.7394 22.6503 30.4001 20.949 30.4001H19.0508C17.3496 30.4001 15.718 29.7394 14.515 28.5631C13.312 27.3869 12.6362 25.7915 12.6362 24.1281V15.872C12.6362 14.2086 13.3119 12.6132 14.515 11.437C15.7179 10.2607 17.3496 9.59997 19.0508 9.59997H20.9408C22.6435 9.59782 24.2771 10.2577 25.4819 11.4341C26.6866 12.6107 27.3635 14.2071 27.3635 15.872V18.4C27.3635 18.6122 27.4497 18.8158 27.6032 18.9657C27.7566 19.1157 27.9648 19.2 28.1817 19.2C28.3987 19.2 28.6069 19.1157 28.7603 18.9657C28.9137 18.8158 28.9999 18.6122 28.9999 18.4V15.872C28.9999 13.7843 28.1518 11.7819 26.6418 10.3058C25.132 8.82931 23.0841 8 20.9491 8H19.0508C16.9157 8 14.8678 8.82931 13.3581 10.3058C11.8482 11.782 11 13.7844 11 15.872V24.128C11 26.2157 11.8482 28.2181 13.3581 29.6942C14.8679 31.1707 16.9158 32 19.0508 32H20.9409C22.355 32.0014 23.7446 31.6386 24.9699 30.948C26.1949 30.2575 27.2126 29.2635 27.9201 28.0662C28.6274 26.869 29 25.5107 29 24.128V23.3999C29 23.1878 28.9138 22.9842 28.7604 22.8342C28.607 22.6842 28.3988 22.5999 28.1818 22.5999C27.9649 22.5999 27.7567 22.6842 27.6032 22.8342C27.4498 22.9842 27.3636 23.1878 27.3636 23.3999L27.3636 23.4Z",
    fill: "#756CD9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemote);
export default __webpack_public_path__ + "static/media/remote.532c2f2a356fa88b8590657043f16ac5.svg";
export { ForwardRef as ReactComponent };